module.exports = __webpack_public_path__ + "static/media/Car Garage 2.b01965fa.svg";